// theHype Ghost Theme — main JS entry

// Import CSS
import '../css/index.css';

// Import JS
import pageNav from './pageNav';
import copyLink from './copyLink';
import newsletter from './newsletter';
import subscribeInjector from './subscribeInjector';
import codeBlocks from './codeBlocks';
import tables from './tables';
import toc from './toc';
import radio from './radio';
import search from './search';
import account from './account';
import ticker from './ticker';
import pjax from './pjax';
import heroCarousel from './heroCarousel';
import rubricCarousel from './rubricCarousel';
import eventsHome from './eventsHome';
import releasesHome from './releasesHome';
import eventsPage from './eventsPage';
import releasesPage from './releasesPage';
import releasesFaq from './releasesFaq';
import mcpPage from './mcpPage';
import lightbox, { markZoomableImages } from './lightbox';
import tweetEmbeds from './tweetEmbeds';

// Once per session — document-delegated listeners and the persistent shell
copyLink();
newsletter();
radio();
search();
account();
pjax();
lightbox();

// Once per page — re-run after every PJAX content swap
function pageInit() {
    pageNav();
    subscribeInjector();
    codeBlocks();
    tables();
    markZoomableImages();
    tweetEmbeds();
    toc();
    ticker();
    heroCarousel();
    rubricCarousel();
    releasesHome();
    eventsHome();
    eventsPage();
    releasesPage();
    releasesFaq();
    mcpPage();
}
pageInit();
window.__thPageInit = pageInit;

// Back/forward cache restores the DOM snapshot without re-running scripts —
// re-sync page state so nothing stale (buttons, tickers) survives.
window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
        pageInit();
    }
});
